const CreationTimeRecipe = {
    $type$: 'Recipe',
    name: 'CreationTime',
    rule: [
        {
            itemprop: 'timestamp',
            itemtype: { type: 'number' }
        },
        {
            itemprop: 'data',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['*']) }
        }
    ]
};
const MetaRecipes = [CreationTimeRecipe];
export default MetaRecipes;
//# sourceMappingURL=MetaRecipes.js.map